import React from 'react';
import { Cell } from 'react-table';
import isEqual from 'lodash/isEqual';
import { FormattedTodo } from '../../types';
import { useFetchCandidateActions } from '../../utils/useFetchCandidateActions';
import { CandidateStatusDropdown } from '../CandidateStatusDropdown/CandidateStatusDropdown';

export interface StatusProps {
  cellData: Cell<FormattedTodo, any>;
}

export const areEqual = (prevProps: StatusProps, nextProps: StatusProps) => {
  const prevOriginal = prevProps.cellData.row.original;
  const nextOriginal = nextProps.cellData.row.original;

  // Using _.isEqual for deep comparison of the relevant parts of the objects
  return isEqual(
    {
      id: prevOriginal.id,
      candidateId: prevOriginal.candidateId,
      title: prevOriginal.title,
      category: prevOriginal.category,
      statusAssignedBy: prevOriginal.statusAssignedBy,
    },
    {
      id: nextOriginal.id,
      candidateId: nextOriginal.candidateId,
      title: nextOriginal.title,
      category: nextOriginal.category,
      statusAssignedBy: nextOriginal.statusAssignedBy,
    },
  );
};

export const Status = React.memo(function Status({ cellData }: StatusProps) {
  const { id, candidateId, ...columnData } = cellData.row.original;

  const [candidateRecruiterActions] = useFetchCandidateActions(id);

  return (
    <CandidateStatusDropdown
      id={id}
      status={columnData.title}
      candidateId={candidateId}
      todoStatus={columnData.todoStatus}
      category={columnData.category}
      setToDoList={/* istanbul ignore next */ () => {}}
      currentDoc={candidateRecruiterActions}
      statusAssignedBy={columnData?.statusAssignedBy}
    />
  );
}, areEqual);
